import { Component, Input } from "@angular/core";

@Component({
    selector: 'app-list-container',
    templateUrl: './list-container.component.html'
})

export class ListContainerComponent {
    @Input() header = "";
    @Input() newEntry;
    constructor() { }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/list-container/list-container.component.ts